export default __webpack_public_path__ + "static/media/17.b7881bc1.png";